import { render, staticRenderFns } from "./AtomIconFile.vue?vue&type=template&id=703f0023&functional=true&"
import script from "./AtomIconFile.vue?vue&type=script&lang=ts&"
export * from "./AtomIconFile.vue?vue&type=script&lang=ts&"
import style0 from "./AtomIconFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports